import { ErrorMessage, MUIIcon, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { FetchStatus, Property } from "../../../../../base/types";

import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import clsx from "clsx";
import { useLookupProperties } from "./LookupProperties";

export const DraftLookupComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useLookupProperties(props);

    const getValue = useCallback(() => {
        if (!bindings) return;

        const binding = bindings.getBinding(Property.InitValue);
        if (!binding || !binding.boundValue) return;

        switch (binding.type) {
            case "Const":
                return `"${binding.boundValue}"`
            case "Expression":
                return `${binding.boundValue?.query}`
            case "Field":
                return `{${binding.boundValue}}`
        }
    }, [bindings])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    const value = getValue();

    const render = () => {
        const { label, required, title } = properties || {}
        const containerClass = label ? className : ''
        const inputClass = label ? '' : className

        return (
            <InputLabel
                htmlFor={control.controlId}
                title={title}
                label={label}
                required={required}
                className={containerClass}>
                <div className={clsx(inputClass, "input-group input-group-sm")}>
                    <div className="form-control form-control-sm">
                        {value}
                    </div>
                    <span className="input-group-text">
                        <MUIIcon iconName="ExpandMoreOutlined" />
                    </span>
                </div>
            </InputLabel>
        )
    }

    return render();
}